<template>
  <div class="message-wrapper" :class="messagePosition" v-if="![TYPES.MSG_TYPE.JOIN].includes(message.type)">
    <message-header :message="message" v-if="!message.isRevoked"/>
    <div v-if="!message.isSupport"  class="c2c-layout" :class="messagePosition">
      <div v-if="!message.isRevoked" class="col-1">
        <!-- 头像 -->
        <avatar v-if="message.evaluate_msg != 3 && (typeof(message.content) == 'string' && message.content.indexOf('out_queue') == -1)" :src="avatar" :isMine="isMine" />
        <div v-else class="noavatar" ></div>
      </div>
        <!-- <div class="col-1" v-else>
            <avatar :src="avatar" :isMine="isMine"/>
        </div> -->
      <div :class="[message.isRevoked?'col-12':'col-2']">
        <!-- 消息主体 -->
        <div class="content-wrapper">
          <message-status-icon v-if="isMine" :message="message" />
          <waiting-element v-if="message.content && message.content.toString().indexOf('out_queue') > -1 " :message="message"/>
          <text-element v-else-if="[TYPES.MSG_TYPE.TEXT, TYPES.MSG_TYPE.QUIT].includes(message.type)" :isMine="isMine" :message="message"/>
		      <rate-element v-else-if="message.type=='text-evaluate'" :message="message" />
          <image-element v-else-if="message.type === TYPES.MSG_TYPE.IMAGE" :isMine="isMine" :message="message"/>
          <geo-element v-else-if="message.type === TYPES.MSG_TYPE.GEO" :isMine="isMine" :message="message"/>
          <file-element v-else-if="message.type === TYPES.MSG_TYPE.FILE" :isMine="isMine" :message="message"/>
          <video-element v-else-if="message.type === TYPES.MSG_TYPE.VIDEO" :isMine="isMine" :message="message"/>
          <illegal-element v-else :isMine="isMine"/>
          <!-- <goods-element
            v-else-if="message.type === TYPES.MSG_TYPE.GOODS"
            :message="message"
          /> -->
          <!-- <span v-else>暂未支持的消息类型：{{message.type}}</span> -->
        </div>
        <!-- <message-footer v-if="showMessageHeader" :message="message" /> -->
      </div>
      <div v-if="!message.isRevoked" class="col-3">
        <!-- 消息状态 -->
      </div>
    </div>
    <!-- 商品链接 -->
    <!-- <div v-else class="support-layout">
      <goods-element
        v-if="message.type === TYPES.MSG_TYPE.GOODS"
        :message="message"
      />
    </div> -->
    <!-- <div class="system-layout" v-if="currentConversationType === TIM.TYPES.CONV_SYSTEM ">
      <div class="col-1">
        <avatar :src="avatar" :type="currentConversationType" />
      </div>
      <div class="col-2">
        <message-header :message="message" />
        <group-system-notice-element :payload="message.payload" :message="message" />
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MessageStatusIcon from './message-status-icon.vue'
import MessageHeader from './message-header'
import ImageElement from '../../pc/message/message-elements/image-element.vue'
import TextElement from '../../pc/message/message-elements/text-element'
import FileElement from '../../pc/message/message-elements/file-element'
import VideoElement from '../../pc/message/message-elements/video-element'
import GeoElement from '../../pc/message/message-elements/geo-element.vue'
import RateElement from '../../pc/message/message-elements/rate-element'
import illegalElement from '../../pc/message/message-elements/illegal-element.vue'
import WaitingElement from '../../pc/message/message-elements/waiting-element.vue'

export default {
  name: 'MessageItem',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  components: {
    MessageHeader,
    MessageStatusIcon,
    ImageElement,
    TextElement,
    GeoElement,
    illegalElement,
	  RateElement,
    FileElement,
    VideoElement,
    WaitingElement,
  },
  data() {
    return {
      renderDom: []
    }
  },
  computed: {
    ...mapState({
      currentConversation: state => state.conversation.currentConversation,
    }),

    avatar() {
      return this.message.headimgurl
    },

    isMine() {
      return this.message.sendFrom == 1 || this.message.sendFrom == 3
    },

    messagePosition() {
      if (this.message.content) {
        if (this.message.content.toString().indexOf('out_queue') > -1) {
          return 'position-center'
        }
      }
      if (
        ['TIMGroupTipElem', 'TIMGroupSystemNoticeElem'].includes(
          this.message.type
        )
      ) {
        return 'position-center'
      }
      if (this.message.isRevoked||this.message.evaluate_msg==1) { // 撤回消息
        return 'position-center'
      }
      if (this.isMine) {
        return 'position-right'
      } else {
        return 'position-left'
      }
    },

    showMessageHeader() {
      if (
        ['TIMGroupTipElem', 'TIMGroupSystemNoticeElem'].includes(
          this.message.type
        )
      ) {
        return false
      }
      if (this.message.isRevoked) { // 撤回消息
        return false
      }
      return true
    }
  },

  methods: {

  }
}
</script>

<style lang="stylus" scoped>
.message-wrapper {
  margin: 20px 0;/*no*/

  .content-wrapper {
    display: flex;
    align-items: center;
  }
}

.group-layout, .c2c-layout, .system-layout {
  display: flex;

  .col-1 {
    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }

  .group-member-avatar {
    cursor: pointer;
  }

  .col-2 {
    display: flex;
    flex-direction: column;
    justify-content center;
    // max-width 50% // 此设置可以自适应宽度，目前由bubble限制
  }

  .col-3 {
    width: 60px;
  }

  &.position-left {
    .col-1 {
      margin-right: 8px;/*no*/
    }
    .col-2 {
      align-items: flex-start;
    }
  }

  &.position-right {
    flex-direction: row-reverse;

    .col-1 {
      margin-left: 8px;/*no*/
    }
    .col-2 {
      align-items: flex-end;
    }
  }

  &.position-center {
    justify-content: center;
  }
}

.c2c-layout {
  .col-2 {
    .base {
      margin-top: 3px;/*no*/
    }
  }
}

.group-layout {
  .col-2 {
    .chat-bubble {
      margin-top: 5px;/*no*/
    }
  }
}

.support-layout {
  margin-top: 20px;/*no*/
}
.noavatar{
  width: 40px;
}
</style>
